import { CircularProgress, Grid } from "@mui/material";
import Modal from "./elements/modal";
import ModalContent from "./elements/modal.content";
import { LoadingModalTypo } from "./styles";

const LoadingModal = ({ open, message, ...rest }) => {
  return (
    <Modal id="loading-modal" open={open} fullWidth={true} maxWidth="xs" {...rest}>
      <ModalContent>
        <Grid container>
          <Grid size={12}>
            <LoadingModalTypo variant="body1" textAlign="center" sx={{ mb: 2 }}>
              {message}
            </LoadingModalTypo>
          </Grid>
          <Grid
            sx={{
              textAlign: "center",
            }}
            size={12}>
            <CircularProgress color="primary" />
          </Grid>
        </Grid>
      </ModalContent>
    </Modal>
  );
};

export default LoadingModal;
